"use client"

import { useState, useEffect } from "react"
import { Container, Row, Col, Button, Carousel } from "react-bootstrap"
import { useParams, Link } from "react-router-dom"
import "../pages/styled/Productdetails.css"

import Y1 from "../assets/SSP/Y1.png";
import Y2 from "../assets/SSP/Y2.png";
import Y3 from "../assets/SSP/Y3.png";
import Y4 from "../assets/SSP/Y4.png";

import B1 from "../assets/SSP/B8.png";
import B2 from "../assets/SSP/B2.png";
import B3 from "../assets/SSP/B3.png";
import B4 from "../assets/SSP/B4.png";
import B5 from "../assets/SSP/B5.png";
import B6 from "../assets/SSP/B6.png";
import B7 from "../assets/SSP/B7.png";
import B8 from "../assets/SSP/B1.png";

import p1 from "../assets/SSP/p1.png";
import p2 from "../assets/SSP/p2.png";
import p3 from "../assets/SSP/p3.png";
import p4 from "../assets/SSP/p4.png";
import p5 from "../assets/SSP/p5.png";
import p6 from "../assets/SSP/p6.png";
import p7 from "../assets/SSP/B7.png";
import p8 from "../assets/SSP/p8.png";
import p9 from "../assets/SSP/p9.png";
import p10 from "../assets/SSP/p10.png";


import B9 from "../assets/SSP/B9.png";
import B10 from "../assets/SSP/B10.png";
import B11 from "../assets/SSP/B11.png";
import B12 from "../assets/SSP/B12.png";


import W1 from "../assets/SSP/W1.png";
import W2 from "../assets/SSP/W4.png";
import W3 from "../assets/SSP/W3.png";
import W4 from "../assets/SSP/W2.png";


import PW1 from "../assets/SSP/PW1.png";
import PW2 from "../assets/SSP/PW2.png";
import PW3 from "../assets/SSP/PW3.png";
import PW4 from "../assets/SSP/PW4.png";
import PW5 from "../assets/SSP/PW5.png";
import PW6 from "../assets/SSP/PW6.png";


import FC1 from "../assets/SSP/FC1.jpeg";
import FC2 from "../assets/SSP/FC2.jpeg";
import FC3 from "../assets/SSP/FC3.jpeg";
import FC4 from "../assets/SSP/FC4.jpeg";

import TIC1 from "../assets/SSP/TIC1.jpeg";
import TIC2 from "../assets/SSP/TIC2.png";
import TIC3 from "../assets/SSP/TIC3.png";
import TIC4 from "../assets/SSP/TIC4.png";

import FF1 from "../assets/SSP/FF1.jpeg";
import FF2 from "../assets/SSP/FF2.jpeg";
import FF3 from "../assets/SSP/FF3.png";
import FF4 from "../assets/SSP/FF4.png";

import TIP1 from "../assets/SSP/Tissuepaper.jpg";
import TIP2 from "../assets/SSP/Tissuepaper2.jpeg";
import TIP3 from "../assets/SSP/Tissuepaper3.jpeg";

import DB from "../assets/SSP/Dustbin.jpeg";
import DB1 from "../assets/SSP/Dustbin1.jpeg";
import DB2 from "../assets/SSP/Dustbin2.jpeg";
import DB3 from "../assets/SSP/Dustbin3.jpeg";

import SB from "../assets/SSP/Softbroom.jpeg";
import SB1 from "../assets/SSP/Softbroom1.jpeg";
import SB2 from "../assets/SSP/Softbroom2.jpeg";
import SB3 from "../assets/SSP/Softbroom3.jpeg";

import CB from "../assets/SSP/Coconut.jpeg";
import CB1 from "../assets/SSP/Coconut1.jpeg";
import CB2 from "../assets/SSP/Coconut2.jpeg";
import CB3 from "../assets/SSP/Coconut3.jpeg";

import TB from "../assets/SSP/Toiletbrush.jpeg";
import TB1 from "../assets/SSP/Toiletbrush1.png";
import TB2 from "../assets/SSP/Toiletbrush2.jpeg";
import TB3 from "../assets/SSP/Toiletbrush3.jpeg";

import YC from "../assets/SSP/Yellowcloth.jpeg";
import YC1 from "../assets/SSP/Yellowcloth1.jpeg";
import YC2 from "../assets/SSP/Yellowcloth2.jpeg";
import YC3 from "../assets/SSP/Yellowcloth3.jpeg";

import NB from "../assets/SSP/Napthalin.jpeg";
import NB1 from "../assets/SSP/Napthalin1.jpeg";
import NB2 from "../assets/SSP/Napthalin2.jpeg";
import NB3 from "../assets/SSP/Napthalin3.jpeg";

import MC from "../assets/SSP/Microcloth.jpg";
import MC1 from "../assets/SSP/Microcloth1.jpeg";
import MC2 from "../assets/SSP/Microcloth2.jpeg";
import MC3 from "../assets/SSP/Microcloth3.jpeg";

import UP from "../assets/SSP/Urinalpad.jpeg";
import UP1 from "../assets/SSP/Urinalpad1.jpeg";
import UP2 from "../assets/SSP/Urinalpad2.jpeg";

import UC from "../assets/SSP/Urinalcube.jpeg";
import UC1 from "../assets/SSP/Urinalcube1.jpeg";
import UC2 from "../assets/SSP/Urinalcube2.jpeg";
import UC3 from "../assets/SSP/Urinalcube3.jpeg";

import MP from "../assets/SSP/Mop.jpeg";
import MP1 from "../assets/SSP/Mop1.jpeg";
import MP2 from "../assets/SSP/Mop2.jpeg";
import MP3 from "../assets/SSP/Mop3.jpeg";

import OP from "../assets/SSP/Odonilairpocket.jpeg";
import OP1 from "../assets/SSP/Odonilairpocket1.jpeg";

import TR from "../assets/SSP/Tissueroll.jpeg";
import TR1 from "../assets/SSP/Tissueroll1.jpeg";
import TR2 from "../assets/SSP/Tissueroll2.jpeg";

import BP from "../assets/SSP/Blichingpowder.jpeg";
import BP1 from "../assets/SSP/Blichingpowder1.jpeg";
import BP2 from "../assets/SSP/Blichingpowder2.jpeg";

import DC from "../assets/SSP/Drumcleaner.jpeg";
import DC1 from "../assets/SSP/Drumcleaner1.jpeg";


import SC from "../assets/SSP/Sinkcleaner.jpeg";
import SC1 from "../assets/SSP/Sinkcleaner1.jpeg";

import AC from "../assets/SSP/Acid.jpeg";
import AC1 from "../assets/SSP/Acid1.jpeg";
function ProductDetail() {
  const { id } = useParams() // Get product ID from URL
  const [activeIndex, setActiveIndex] = useState(0)
  const [activeRelatedIndex, setActiveRelatedIndex] = useState({})

  // Initialize state for tracking which related product is showing carousel
  useEffect(() => {
    const initialState = {}
    housekeepingProducts.forEach((product) => {
      initialState[product.id] = false
    })
    setActiveRelatedIndex(initialState)
  }, [])

  // Toggle carousel display for related products
  const toggleRelatedProductCarousel = (productId) => {
    setActiveRelatedIndex((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }))
  }

  // Sample housekeeping products data
  const housekeepingProducts = [
    {
      id: 1,
      name: "Floor Cleaner",
      category: "Equipment",
      quantity:'500ml',
      price: "₹90",
      description:
        "Our industrial cleaning equipment is designed for heavy-duty cleaning tasks in commercial and industrial settings. These high-efficiency tools provide superior cleaning performance while reducing labor costs and improving productivity.",
      features: [
        "Heavy-duty construction for durability",
        "Ergonomic design for operator comfort",
        "Energy-efficient operation",
        "Low maintenance requirements",
        "Compatible with eco-friendly cleaning solutions",
        "Adjustable settings for different surfaces",
      ],
      specifications: {
        "Power Source": "Electric/Battery",
        "Cleaning Width": "24-36 inches",
        "Tank Capacity": "15-30 gallons",
        Weight: "120-1  80 lbs",
        Warranty: "2-year warranty included",
      },
      images: [
        Y3,Y2,Y1,Y4,
      ],
      relatedProducts: [
        {
          id: 2,
          name: "Floor Cleaner",
          images: [
            B2,,B7,B8,
          ],
          quantity:'500ml',
          price:'₹90',
        },
        {
          id: 3,
          name: "Hand Wash",
          images: [
           p1,p2,p3,
          ],
          price:'₹100',
        },
        {
          id: 4,
          name: "Room Freshner",
          images: [
            PW2,PW1,PW3,
          ],
          price:'₹120',
        },
      ],
    },
    {
      id: 2,
      name: "Dish Wash",
      category: "Solutions",
      quantity:'500ml',
      price:'₹90',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
        B2,,B7,B8,
      ],
      relatedProducts: [
        {
          id: 1,
          name: "Hand Wash",
          images: [
            p1,p2,p3,
          ],
          price:'₹100',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
            PW2,PW1,PW3
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Floor Cleaner",
          images: [
           Y1,Y2,Y3,
          ],
          price: "₹90",
        },
      ],
    },
    // Additional products would be defined here
    {
      id: 3,
      name: "Hand Wash",
      category: "Solutions",
      quantity:'250ml',
      price:'₹100',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
        p1,p2,p3,
      ],
      relatedProducts: [
        {
          id: 1,
          name: "Room Freshner",
          images: [
            PW2,PW1,PW3
          ],
          price:'₹120',
        },
        {
          id: 5,
          name: "Dish Wash",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
        {
          id: 6,
          name: "Floor Cleaner",
          images: [
            Y2,Y1,Y4
          ],
          price:'₹90',
        },
      ],
    },

    // Additional products would be defined here
    {
      id: 4,
      name: "Glass Cleaner",
      category: "Solutions",
      quantity:'500ml',
      price:'₹100',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
       B9,B10,B11,B12,
      ],
      relatedProducts: [
        {
          id: 1,
          name: "Hand Wash",
          images: [
            p1,p2,p3,
          ],
          price:'₹100',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW1,PW3,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Floor Cleaner",
          images: [
          B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },
    // Additional products would be defined here
    {
      id: 5,
      name: "Liquid Detergent",
      category: "Solutions",
      quantity:'250ml',
      price:'₹100',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
        W2,W1,W3,W4
      ],
      relatedProducts: [
        {
          id: 1,
          name: "Hand Wash",
          images: [
            p1,p2,p3,
          ],
          price:'₹100',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW1,PW3,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Floor Cleaner",
          images: [
             Y1,Y2,Y3,
          ],
          price:'₹90',
        },
      ],
    },

    // Additional products would be defined here
    {
      id: 6,
      name: "Room Freshener",
      category: "Solutions",
      quantity:'250ml',
      price:'₹120',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
       PW1,PW2,PW3,PW4,PW5,PW6,
      ],
      relatedProducts: [
        {
          id: 1,
          name: "Hand Wash",
          images: [
            p1,p2,p3,
          ],
          price:'₹100',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },

     // Additional products would be defined here
     {
      id: 7,
      name: "Toilet Cleaner",
      category: "Bathroom Cleaners",
      quantity:'500ml',
      price:'₹90',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
        FC1,FC2,FC3,FC4,
      ],
      relatedProducts: [
        {
          id: 7,
          name: "Toilet Cleaner",
          images: [
            FC1,FC2,FC3,FC4,
          ],
          price:'₹90',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },
     // Additional products would be defined here
     {
      id: 8,
      name: "Tiles Cleaner",
      category: "Surface Cleaners",
      quantity:'650ml',
      price:'₹130',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
       TIC1, TIC2, TIC3, TIC4,
      ],
      relatedProducts: [
        {
          id: 7,
          name: "Toilet Cleaner",
          images: [
            FC1,FC2,FC3,FC4,
          ],
          price:'₹90',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },

    // Additional products would be defined here
    {
      id: 9,
      name: "Fabric Freshener",
      category: "SLaundry Care",
      quantity:'650ml',
      price:'₹120',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
       FF1,FF4,FF3,FF2,
      ],
      relatedProducts: [
        {
          id: 7,
          name: "Toilet Cleaner",
          images: [
            FC1,FC2,FC3,FC4,
          ],
          price:'₹90',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },
    // Additional products would be defined here
    {
      id: 10,
      name: "Tissue Paper",
      category: "Paper Products",
      quantity:'1No',
      price:'₹40',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
       TIP1,TIP2,TIP3,
      ],
      relatedProducts: [
        {
          id: 7,
          name: "Toilet Cleaner",
          images: [
            FC1,FC2,FC3,FC4,
          ],
          price:'₹90',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },

    // Additional products would be defined here
    {
      id: 11,
      name: "Dustbin Cover ",
      category: "Waste Management",
      quantity:'1NO',
      rate:'₹60',
      description:
        "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
      features: [
        "Biodegradable formulation",
        "Non-toxic ingredients",
        "Effective against common dirt and stains",
        "Pleasant natural fragrances",
        "Safe for use around children and pets",
        "Concentrated formula for economic use",
      ],
      specifications: {
        Formulation: "Liquid concentrate",
        "Package Size": "1 gallon",
        "Dilution Ratio": "1:10 to 1:30",
        "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
        "Shelf Life": "2 years",
      },
      images: [
        DB,DB1,DB2,DB3,
      ],
      relatedProducts: [
        {
          id: 7,
          name: "Toilet Cleaner",
          images: [
            FC1,FC2,FC3,FC4,
          ],
          price:'₹90',
        },
        {
          id: 5,
          name: "Room Freshner",
          images: [
          PW2,PW3,PW1,
          ],
          price:'₹120',
        },
        {
          id: 6,
          name: "Glass Cleaner",
          images: [
           B1,B2,B3,
          ],
          price:'₹90',
        },
      ],
    },
      // Additional products would be defined here
      {
        id: 12,
        name: "Soft Broom",
        category: "Cleaning Tools",
        quantity:'1No',
        price:'₹120',
        description:
          "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
        features: [
          "Biodegradable formulation",
          "Non-toxic ingredients",
          "Effective against common dirt and stains",
          "Pleasant natural fragrances",
          "Safe for use around children and pets",
          "Concentrated formula for economic use",
        ],
        specifications: {
          Formulation: "Liquid concentrate",
          "Package Size": "1 gallon",
          "Dilution Ratio": "1:10 to 1:30",
          "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
          "Shelf Life": "2 years",
        },
        images: [
          SB,SB1,SB2,SB3,
        ],
        relatedProducts: [
          {
            id: 1,
            name: "Hand Wash",
            images: [
              p1,p2,p3,
            ],
            price:'₹100',
          },
          {
            id: 5,
            name: "Room Freshner",
            images: [
            PW2,PW1,PW3,
            ],
            price:'₹120',
          },
          {
            id: 6,
            name: "Floor Cleaner",
            images: [
               Y1,Y2,Y3,
            ],
            price:'₹90',
          },
        ],
      },
  // Additional products would be defined here
  {
    id: 13,
    name: "Coconut Broom",
    category: "Cleaning Tools",
    quantity:'1No',
    price:'₹55',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
      CB,CB1,CB2,CB3,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 14,
    name: "Toilet Cleaning Brush",
    category: "Cleaning Accessories",
    quantity:'1No',
    price:'₹90',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
      TB,TB1,TB2,TB3,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },

  // Additional products would be defined here
  {
    id: 15,
    name: "Yellow Cloth",
    category: "Cleaning Accessories",
    quantity:'1No',
    price:'₹10',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     YC,YC1,YC2,YC3,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 16,
    name: "Naphthalene Balls",
    category: "Pest Control",
    quantity:'1/2kg',
    price:'₹90',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     NB , NB1,NB2,NB3,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 17,
    name: "Microfiber Cloth",
    category: "Cleaning Accessories",
    quantity:'1No',
    price:'₹65',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     MC,MC1,MC2,MC3,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 18,
    name: "Urinal Pad",
    category: "Bathroom Maintenance",
    quantity:'1poc',
    price:'₹80',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
    UP , UP1, UP2, 
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
 
  {
    id: 19,
    name: "Urinal Cube",
    category: "Bathroom Maintenance",
    quantity:'1poc',
    price:'₹60',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     UC,UC1,UC2,UC3
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 20,
    name: "Mob",
    category: "Cleaning Tools",
    quantity:'1No',
    price:'₹100',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
    MP,MP1,MP2
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 21,
    name: "Odonil Air Pocket",
    category: "Air Fresheners",
    quantity:'1No',
    price:'₹50',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     OP,OP1,
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
  // Additional products would be defined here
  {
    id: 22,
    name: "Tissue Roll",
    category: "Paper Products",
    quantity:'1No',
    price:'₹60',
    description:
      "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
    features: [
      "Biodegradable formulation",
      "Non-toxic ingredients",
      "Effective against common dirt and stains",
      "Pleasant natural fragrances",
      "Safe for use around children and pets",
      "Concentrated formula for economic use",
    ],
    specifications: {
      Formulation: "Liquid concentrate",
      "Package Size": "1 gallon",
      "Dilution Ratio": "1:10 to 1:30",
      "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
      "Shelf Life": "2 years",
    },
    images: [
     TR , TR1,TR2
    ],
    relatedProducts: [
      {
        id: 1,
        name: "Hand Wash",
        images: [
          p1,p2,p3,
        ],
        price:'₹100',
      },
      {
        id: 5,
        name: "Room Freshner",
        images: [
        PW2,PW1,PW3,
        ],
        price:'₹120',
      },
      {
        id: 6,
        name: "Floor Cleaner",
        images: [
           Y1,Y2,Y3,
        ],
        price:'₹90',
      },
    ],
  },
// Additional products would be defined here
{
  id: 23,
  name: "Bleaching Powder",
  category: "Disinfectants",
  quantity:'1kg',
  price:'₹40',
  description:
    "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
  features: [
    "Biodegradable formulation",
    "Non-toxic ingredients",
    "Effective against common dirt and stains",
    "Pleasant natural fragrances",
    "Safe for use around children and pets",
    "Concentrated formula for economic use",
  ],
  specifications: {
    Formulation: "Liquid concentrate",
    "Package Size": "1 gallon",
    "Dilution Ratio": "1:10 to 1:30",
    "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
    "Shelf Life": "2 years",
  },
  images: [
   BP,BP1,BP2
  ],
  relatedProducts: [
    {
      id: 1,
      name: "Hand Wash",
      images: [
        p1,p2,p3,
      ],
      price:'₹100',
    },
    {
      id: 5,
      name: "Room Freshner",
      images: [
      PW2,PW1,PW3,
      ],
      price:'₹120',
    },
    {
      id: 6,
      name: "Floor Cleaner",
      images: [
         Y1,Y2,Y3,
      ],
      price:'₹90',
    },
  ],
},
// Additional products would be defined here
{
  id: 24,
  name: "IFB Washing Machine Drum Cleaner",
  category: "Appliance Cleaners",
  quantity:'1poc',
  price:'₹150',
  description:
    "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
  features: [
    "Biodegradable formulation",
    "Non-toxic ingredients",
    "Effective against common dirt and stains",
    "Pleasant natural fragrances",
    "Safe for use around children and pets",
    "Concentrated formula for economic use",
  ],
  specifications: {
    Formulation: "Liquid concentrate",
    "Package Size": "1 gallon",
    "Dilution Ratio": "1:10 to 1:30",
    "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
    "Shelf Life": "2 years",
  },
  images: [
   DC,DC1
  ],
  relatedProducts: [
    {
      id: 1,
      name: "Hand Wash",
      images: [
        p1,p2,p3,
      ],
      price:'₹100',
    },
    {
      id: 5,
      name: "Room Freshner",
      images: [
      PW2,PW1,PW3,
      ],
      price:'₹120',
    },
    {
      id: 6,
      name: "Floor Cleaner",
      images: [
         Y1,Y2,Y3,
      ],
      price:'₹90',
    },
  ],
},
// Additional products would be defined here
{
  id: 25,
  name: "Sink Cleaner",
  category: "Kitchen Cleaners",
  quantity:'1poc',
  price:'₹28',
  description:
    "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
  features: [
    "Biodegradable formulation",
    "Non-toxic ingredients",
    "Effective against common dirt and stains",
    "Pleasant natural fragrances",
    "Safe for use around children and pets",
    "Concentrated formula for economic use",
  ],
  specifications: {
    Formulation: "Liquid concentrate",
    "Package Size": "1 gallon",
    "Dilution Ratio": "1:10 to 1:30",
    "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
    "Shelf Life": "2 years",
  },
  images: [
   SC,SC1
  ],
  relatedProducts: [
    {
      id: 1,
      name: "Hand Wash",
      images: [
        p1,p2,p3,
      ],
      price:'₹100',
    },
    {
      id: 5,
      name: "Room Freshner",
      images: [
      PW2,PW1,PW3,
      ],
      price:'₹120',
    },
    {
      id: 6,
      name: "Floor Cleaner",
      images: [
         Y1,Y2,Y3,
      ],
      price:'₹90',
    },
  ],
},
// Additional products would be defined here
{
  id: 26,
  name: "Acid",
  category: "Heavy-Duty Cleaners",
  quantity:'1L',
  price:'₹25',
  description:
    "Our eco-friendly cleaning solutions are formulated to provide effective cleaning while being gentle on the environment. These biodegradable products are safe for use in homes, offices, and commercial spaces.",
  features: [
    "Biodegradable formulation",
    "Non-toxic ingredients",
    "Effective against common dirt and stains",
    "Pleasant natural fragrances",
    "Safe for use around children and pets",
    "Concentrated formula for economic use",
  ],
  specifications: {
    Formulation: "Liquid concentrate",
    "Package Size": "1 gallon",
    "Dilution Ratio": "1:10 to 1:30",
    "pH Level": "7.0-8.5 (neutral to slightly alkaline)",
    "Shelf Life": "2 years",
  },
  images: [
   AC,AC1
  ],
  relatedProducts: [
    {
      id: 1,
      name: "Hand Wash",
      images: [
        p1,p2,p3,
      ],
      price:'₹100',
    },
    {
      id: 5,
      name: "Room Freshner",
      images: [
      PW2,PW1,PW3,
      ],
      price:'₹120',
    },
    {
      id: 6,
      name: "Floor Cleaner",
      images: [
         Y1,Y2,Y3,
      ],
      price:'₹90',
    },
  ],
},
  ]

  // Find the product based on the ID from URL
  const product = housekeepingProducts.find((p) => p.id === Number.parseInt(id)) || housekeepingProducts[0]

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex)
  }

  const handleThumbnailClick = (index) => {
    setActiveIndex(index)
  }

  return (
    <>
        {/* Hero Banner with PRODUCTS text */}
        <div
  className="contact-header"
  style={{
    backgroundImage:
      "url('https://media.istockphoto.com/id/510693044/photo/house-cleaning-product-on-wood-table.jpg?s=612x612&w=0&k=20&c=EZfeRCDgSMPnqG684zQBOqyNfDGx9JWTXS1Q2Lhrjy4=')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  }}
>
  <div className="header-content">
    <h1
      className="header-title"
      style={{
        fontSize: "3rem",
        fontWeight: "bold",
        color: "#fff",
        textTransform: "uppercase",
      }}
    >
      PRODUCT DETAILS
    </h1>
  </div>
</div>
      <section className="product-detail-section py-5">
        <Container>
          <Row className="mb-5">
            <Col lg={6}>
              <div className="product-gallery">
                <Carousel
                  activeIndex={activeIndex}
                  onSelect={handleSelect}
                  interval={null}
                  className="main-carousel mb-3"
                >
                  {product.images.map((image, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 main-product-img"
                        src={image || "/placeholder.svg"}
                        alt={`${product.name} - Image ${index + 1}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>

                <div className="thumbnails-container">
                  {product.images.map((image, index) => (
                    <div
                      key={index}
                      className={`thumbnail ${activeIndex === index ? "active" : ""}`}
                      onClick={() => handleThumbnailClick(index)}
                    >
                      <img src={image || "/placeholder.svg"} alt={`Thumbnail ${index + 1}`} className="thumbnail-img" />
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="product-info">
                <div className="product-category-badge">{product.category}</div>
                <h1 className="product-name">{product.name}</h1>
                <div className="product-price">Quantity  : {product.quantity}</div>
                <div className="product-price">Price : {product.price}</div>
                <div className="product-rating mb-3">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-half"></i>
                  <span className="rating-count">(24 reviews)</span>
                </div>

                <p className="product-description">{product.description}</p>

                <div className="product-features mb-4">
                  <h4>Key Features</h4>
                  <ul>
                    {product.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="product-actions">
                  <Button variant="success" className="btn-request-quote">
                    Request a Quote
                  </Button>
                  <Button variant="outline-success" className="btn-download-brochure">
                    <i className="bi bi-download me-2"></i>
                    Download Brochure
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col>
              <div className="product-tabs">
                <ul className="nav nav-tabs" id="productTabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="specifications-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#specifications"
                      type="button"
                      role="tab"
                      aria-controls="specifications"
                      aria-selected="true"
                    >
                      Specifications
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="usage-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#usage"
                      type="button"
                      role="tab"
                      aria-controls="usage"
                      aria-selected="false"
                    >
                      Usage Instructions
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="reviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reviews"
                      type="button"
                      role="tab"
                      aria-controls="reviews"
                      aria-selected="false"
                    >
                      Reviews
                    </button>
                  </li>
                </ul>
                <div className="tab-content p-4 border border-top-0 rounded-bottom" id="productTabsContent">
                  <div
                    className="tab-pane fade show active"
                    id="specifications"
                    role="tabpanel"
                    aria-labelledby="specifications-tab"
                  >
                    <h4>Technical Specifications</h4>
                    <table className="table table-striped">
                      <tbody>
                        {Object.entries(product.specifications).map(([key, value], index) => (
                          <tr key={index}>
                            <th>{key}</th>
                            <td>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="tab-pane fade" id="usage" role="tabpanel" aria-labelledby="usage-tab">
                    <h4>How to Use This Product</h4>
                    <p>Follow these steps for optimal results:</p>
                    <ol>
                      <li>Prepare the surface by removing loose debris</li>
                      <li>Apply the product according to the recommended dilution ratio</li>
                      <li>Allow the product to work for the specified dwell time</li>
                      <li>Scrub if necessary for stubborn soils</li>
                      <li>Rinse thoroughly with clean water</li>
                      <li>Allow to dry completely before use</li>
                    </ol>
                    <p>
                      <strong>Note:</strong> Always test in an inconspicuous area before full application.
                    </p>
                  </div>
                  <div className="tab-pane fade" id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                    <h4>Customer Reviews</h4>
                    <p>This product has received positive feedback from our customers.</p>
                    <div className="review-summary mb-4">
                      <div className="overall-rating">4.5</div>
                      <div className="rating-stars">
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-fill"></i>
                        <i className="bi bi-star-half"></i>
                      </div>
                      <div className="review-count">Based on 24 reviews</div>
                    </div>
                    <Button variant="outline-success" className="btn-write-review">
                      Write a Review
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="related-products">
            <h3 className="section-title">Related Products</h3>
            <div className="title-underline mb-4"></div>
            <Row>
              {product.relatedProducts.map((relatedProduct) => (
                <Col md={4} sm={6} key={relatedProduct.id} className="mb-4">
                  <div className="related-product-card">
                    <div className="related-product-img-container">
                      {activeRelatedIndex[relatedProduct.id] ? (
                        <Carousel interval={3000} className="related-product-carousel">
                          {relatedProduct.images.map((img, imgIndex) => (
                            <Carousel.Item key={imgIndex}>
                              <img
                                className="d-block w-100 related-product-img"
                                src={img || "/placeholder.svg"}
                                alt={`${relatedProduct.name} - Image ${imgIndex + 1}`}
                              />
                            </Carousel.Item>
                          ))}
                        </Carousel>
                      ) : (
                        <img
                          src={relatedProduct.images[0] || "/placeholder.svg"}
                          alt={relatedProduct.name}
                          className="related-product-img"
                          onClick={() => toggleRelatedProductCarousel(relatedProduct.id)}
                        />
                      )}
                    </div>
                    <div className="related-product-info">
                      <h5 className="related-product-name">{relatedProduct.name}</h5>
                      <div className="related-product-price">{relatedProduct.price}</div>
                      <div className="d-flex justify-content-between mt-2">
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => toggleRelatedProductCarousel(relatedProduct.id)}
                        >
                          {activeRelatedIndex[relatedProduct.id] ? "Hide Images" : "View Images"}
                        </Button>
                        <Link to={`/product/${relatedProduct.id}`}>
                          <Button variant="success" size="sm">
                            View Details
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>
    </>
  )
}

export default ProductDetail

